import React from 'react'

/* see pdp-view */
/* this is shamelessly stolen from https://github.com/imbhargav5/rooks/blob/master/packages/outside-click/README.md */
/* they only provide non-transpiled versions which breaks in IE11 so we copied it over and transpile it on our own  */

const useOutsideClick = (ref: React.RefObject<HTMLElement>, handler: (any) => void, when = true): void => {
  const savedHandler = React.useRef(handler)
  const memoizedCallback = React.useCallback((e) => {
    if (ref && ref.current && !ref.current.contains(e.target)) {
      savedHandler.current(e)
    }
  }, [])

  React.useEffect(() => {
    savedHandler.current = handler
  })

  React.useEffect(() => {
    if (when) {
      document.addEventListener('click', memoizedCallback)
      document.addEventListener('ontouchstart', memoizedCallback)
      return () => {
        document.removeEventListener('click', memoizedCallback)
        document.removeEventListener('ontouchstart', memoizedCallback)
      }
    }
  }, [ref, handler, when])
}

export default useOutsideClick
